import { useEffect, useState } from "react";
import { Policy } from "../../lib/Policy";
import { getCurrentTermsOfUsePolicy } from "../../api/LegalApi";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

export function CguPage() {
    const [searchParams] = useSearchParams();
    const { i18n } = useTranslation()
    const [terms, setTerms] = useState<string>("")

    const clientId = process.env.REACT_APP_API_CLIENT_ID as string

    useEffect(() => {
        if (clientId && i18n?.language && searchParams) {
            getCurrentTermsOfUsePolicy({
                clientId,
                language: searchParams.get('kc_locale') || i18n.language
            }).then(({ data }) => setTerms(data?.data?.terms))
        }
    }, [clientId, searchParams])


    return <div style={{ padding: '1rem' }}>
        <Policy terms={terms} />
    </div>
}